// Browser-chrome theme colors (used for the <meta name="theme-color"> tag).
// We support only a light theme for static pages and a dark theme for the editor.
//
// THEME_COLOR_DARK must stay in sync with `--color-ppm-gray-darker` in
// src/global.css (the page background applied via the `.dark` class).
export const THEME_COLOR_DARK = "#181819";
export const THEME_COLOR_LIGHT = "#ffffff";
